/**
 * Add classes to an scrollable element to represent its scroll state.
 */
export default class FadePanel {
  constructor(el) {
    this.el = (el instanceof Element)
      ? el
      : document.querySelector(el);

    this.container = this.el
      ? this.el.parentNode
      : null;

    this.classnames = {
      top: 'fadepanel-top',
      bottom: 'fadepanel-bottom',
      left: 'fadepanel-left',
      right: 'fadepanel-right',
    };

    this.onScroll = this.update.bind(this);

    if (this.container) {
      this.el.addEventListener('scroll', this.onScroll);
      this.onScroll();
    }
  }

  unload() {
    this.el.removeEventListener('scroll', this.onScroll);
  }

  update() {
    const classes = this.container.className.split(' ');

    const isLeft = this.el.scrollLeft > 0;
    const leftIndex = classes.indexOf(this.classnames.left);
    if (isLeft && leftIndex === -1) classes.push(this.classnames.left);
    if (!isLeft && leftIndex !== -1) classes.splice(leftIndex, 1);

    const isRight = this.el.scrollLeft < this.el.scrollWidth - this.el.clientWidth;
    const rightIndex = classes.indexOf(this.classnames.right);
    if (isRight && rightIndex === -1) classes.push(this.classnames.right);
    if (!isRight && rightIndex !== -1) classes.splice(rightIndex, 1);

    const isTop = this.el.scrollTop > 0;
    const topIndex = classes.indexOf(this.classnames.top);
    if (isTop && topIndex === -1) classes.push(this.classnames.top);
    if (!isTop && topIndex !== -1) classes.splice(topIndex, 1);

    const bottomIndex = classes.indexOf(this.classnames.bottom);
    const isBottom = this.el.scrollTop < this.el.scrollHeight - this.el.clientHeight;
    if (isBottom && bottomIndex === -1) classes.push(this.classnames.bottom);
    if (!isBottom && bottomIndex !== -1) classes.splice(bottomIndex, 1);

    this.container.className = classes.join(' ');
  }
}
